import React from "reactn";

export const PresentationFilterContext = React.createContext("");
